import { useState } from 'react'
import ConfirmationCodeField, {
  CODE_LENGTH
} from 'components/ui/ConfirmationCodeField'
import getMutationError from 'utils/getMutationError'

import { useEmailVerificationCodeVerify } from './types/EmailVerificationCodeVerify'

type Props = {
  onSuccess: (emailToken: string) => void
  email: string
}

export default function EmailConfirmationCodeForm({ onSuccess, email }: Props) {
  const [code, setCode] = useState('')
  const [error, setError] = useState<string | undefined>(undefined)
  const [verifying, setVerifying] = useState(false)
  const [verifyCode] = useEmailVerificationCodeVerify({})

  const onVerifyCode = async (value: string) => {
    if (value.length < CODE_LENGTH || verifying) return
    setVerifying(true)
    try {
      const response = await verifyCode({ variables: { code: value, email } })
      const mutationError = getMutationError(response!)
      if (mutationError) {
        setError(mutationError)
      } else {
        onSuccess(response!.data!.emailVerificationCodeVerify!.emailToken!)
      }
    } finally {
      setVerifying(false)
    }
  }

  return (
    <ConfirmationCodeField
      className="mb-5"
      description={`Enter the ${CODE_LENGTH}-digit code from email`}
      disabled={verifying}
      error={error}
      onChange={(value) => {
        setCode(value)
        setError(undefined)
      }}
      onComplete={onVerifyCode}
      value={code}
    />
  )
}
